export default class World {
    constructor(width, height) {
        this.width = width;
        this.height = height;
        this.entities = [];
        this.trails = [];
    }

    // efficient way for entities to ask world if there is a trail in a position
    hasTrailAtPosition(position) {
        // // return this.trails.some(trailPosition =>
        // //     Math.abs(trailPosition.x - position.x) < 10 &&
        // //     Math.abs(trailPosition.y - position.y) < 10
        // // );
        // need to return that position 
        return this.trails.find(trailPosition =>
            Math.abs(trailPosition.x - position.x) < 10 &&
            Math.abs(trailPosition.y - position.y) < 10
        );
    }
    // shift a specific position from the world's trails
    shiftTrailPosition(position) {
        // console.log('Shifting trail position:', position);
        const index = this.trails.findIndex(trailPosition =>
            Math.abs(trailPosition.x - position.x) < 10 &&
            Math.abs(trailPosition.y - position.y) < 10
        );
        if (index !== -1) {
            this.trails.splice(index, 1);
        }
        // THIS IS NOT VALID BECAUSE IT USES POINT_SIZE
        // check that hasNotTrailAtPosition(position) is still valid
        // if (this.hasTrailAtPosition(position)) {
        //     console.error('Warning: Position still exists in trails after shifting:', position);
        // }
        if (this.trails.find(trailPosition =>
            trailPosition.x === position.x &&
            trailPosition.y === position.y &&
            trailPosition.getEntity().id === position.getEntity().id &&
            trailPosition.timestamp === position.timestamp
        )) {   
            // console.error('Warning: Position still exists in trails after shifting:', position);
            // console.log('Current trails:', this.trails);
        }
    }
    // UNTESTED
    // efficient way for entities to ask world if there is a mark in a position
    // // hasMarkAtPosition(position) {
    // //     return this.entities.some(entity =>
    // //         entity.marks.some(mark =>
    // //             Math.abs(mark.x - position.x) < 10 &&
    // //             Math.abs(mark.y - position.y) < 10
    // //         )
    // //     );
    // // }
    addEntity(entity) {
        this.entities.push(entity);
    }

    getOtherTrails(entityId) {
        return this.entities
            .filter(e => e.id !== entityId)
            .flatMap(e => e.trail);
    }
    getOtherEntities(entity) {
        return this.entities.filter(e => e.id !== entity.id);
    }

    // Kill entity
    killEntity(entityId) {
        // Remove entity from entities array
        this.entities = this.entities.filter(e => e.id !== entityId);
        // Remove all trails belonging to this entity
        this.trails = this.trails.filter(trailPosition => {
            if (typeof trailPosition.getEntity === 'function') {
                return trailPosition.getEntity().id !== entityId;
            }
            return true;
        });
    }


    // update() {
    //     console.log('Updating world with entities');
    //     this.entities.forEach(entity => {
    //         entity.move();
    //     });

    //     for (let i = 0; i < this.entities.length; i++) {
    //         for (let j = i + 1; j < this.entities.length; j++) {
    //             if (this.entities[i].isCollidingWith(this.entities[j])) {
    //                 this.entities[i].onInteract(this.entities[j]);
    //                 this.entities[j].onInteract(this.entities[i]);
    //             }
    //         }
    //     }
    // }
}
